async function init() {
    const { loadApp } = await import('./bootstrap');
    return loadApp();
}

init().catch((reason) => {
    console.error('init error', reason);
});
